<template>
  <section class="trust-band" aria-label="لماذا تختارنا">
    <div class="container">
      <div class="trust-inner">
        <div class="trust-header">
          <h2>لماذا عقارات الكويت؟</h2>
          <p class="muted">خبرة، جودة، وثقة في كل صفقة</p>
        </div>
        <div class="trust-cards">
          <div v-for="item in items" :key="item.title" class="trust-card">
            <div class="trust-icon" aria-hidden="true">
              <svg
                viewBox="0 0 24 24"
                width="24"
                height="24"
                v-html="item.icon"
              />
            </div>
            <h3>{{ item.title }}</h3>
            <p class="muted">{{ item.text }}</p>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>
const items = [
  {
    title: "جودة مضمونة",
    text: "جميع العقارات معروضة بمواصفات دقيقة وصور حقيقية.",
    icon: '<path fill="currentColor" d="M12 1L3 5v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V5l-9-4z"/>',
  },
  {
    title: "تغطية شاملة",
    text: "عقارات في جميع محافظات الكويت — من السالمية إلى الأحمدي.",
    icon: '<path fill="currentColor" d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7z"/>',
  },
  {
    title: "حماية وشفافية",
    text: "عمليات واضحة ودعم متخصص في كل مرحلة من الشراء أو الإيجار.",
    icon: '<path fill="currentColor" d="M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zM9 6c0-1.66 1.34-3 3-3s3 1.34 3 3v2H9V6z"/>',
  },
];
</script>

<style scoped>
.trust-band {
  background: var(--brand);
  padding-block: 48px;
}

.trust-inner {
  display: flex;
  flex-direction: column;
  gap: 32px;
}

.trust-header {
  text-align: center;
}

.trust-header h2 {
  color: #fff;
  font-size: 1.375rem;
  margin-bottom: 8px;
}

.trust-header p {
  color: rgba(255, 255, 255, 0.75);
  margin: 0;
}

.trust-cards {
  display: grid;
  grid-template-columns: 1fr;
  gap: var(--section-gap);
}

@media (min-width: 768px) {
  .trust-cards {
    grid-template-columns: repeat(3, 1fr);
  }
}

.trust-card {
  background: var(--surface-card);
  border-radius: var(--radius-md);
  padding: var(--card-padding);
  box-shadow: var(--shadow-sm);
}

.trust-icon {
  width: 48px;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--brand-muted);
  color: var(--brand);
  border-radius: var(--radius-md);
  margin-bottom: 16px;
}

.trust-card h3 {
  font-size: 1rem;
  font-weight: 600;
  margin-bottom: 8px;
}

.trust-card p {
  font-size: 0.875rem;
  margin: 0;
  line-height: 1.5;
}
</style>
